import React from 'react';
import { Grid } from '@mui/material';
import SparkRunStatus from './SparkRunStatus';
import { UNIQUE_SELECTOR_ID } from 'constants/index';
import { useStatusBarStore } from 'stores';
import { useLocation, useSearchParams } from 'react-router-dom';
import MemoryCreation from './MemoryCreation';

function StatusBar() {
  const ref = React.useRef<HTMLDivElement | null>(null);
  const setStatusBarHeight = useStatusBarStore(
    (state) => state.setStatusBarHeight
  );
  const [searchParams] = useSearchParams();

  const setStatusConfig = useStatusBarStore((state) => state.setStatusConfig);
  const statusBarType = useStatusBarStore((state) => state.statusBarType);
  const queryRunID = searchParams.get('run_id');
  const { pathname } = useLocation();

  const statusBarID = useStatusBarStore((state) => state.statusBarID);

  React.useEffect(() => {
    const queryArray = pathname.split('/');
    const querySparkID = queryArray[queryArray.length - 1];
    if (!statusBarID && queryRunID) {
      setStatusConfig({
        statusBarType: 'sparkRun',
        statusBarID: queryRunID,
        secondaryStatusID: querySparkID,
      });
    }
  }, [pathname, queryRunID, setStatusConfig, statusBarID, statusBarType]);

  React.useEffect(() => {
    if (!ref.current) return;

    const resizeObserver = new ResizeObserver((resizeObserverEntries) => {
      window.requestAnimationFrame((): void | undefined => {
        if (
          !Array.isArray(resizeObserverEntries) ||
          !resizeObserverEntries.length
        ) {
          return;
        }
        const statusBarContainer = resizeObserverEntries.find(
          (entry) =>
            entry.target.id === UNIQUE_SELECTOR_ID.STATUSBAR_QUEUE_PROGRESS
        );

        const rectHeight = statusBarContainer?.contentRect.height;
        setStatusBarHeight(rectHeight || 0);
      });
    });
    resizeObserver.observe(ref.current);
    return () => resizeObserver.disconnect();
  }, [setStatusBarHeight]);

  return (
    <Grid container ref={ref} id={UNIQUE_SELECTOR_ID.STATUSBAR_QUEUE_PROGRESS}>
      {statusBarType === 'sparkRun' && <SparkRunStatus renderInHeader={true} />}
      {statusBarType === 'memoryCreation' && <MemoryCreation />}
    </Grid>
  );
}

export default StatusBar;
